function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.325.542L16.56 12.6a1 1 0 01-.858 1.514H1.234A1 1 0 01.376 12.6L7.61.542a1 1 0 011.715 0z"
});
var _ref3 = /*#__PURE__*/React.createElement("text", {
  fill: "#2BBBBB",
  fontFamily: "Avenir-Heavy, Avenir",
  fontSize: 10,
  fontWeight: 600,
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 6,
  y: 11
}, "!"));
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.614c677f.svg";
export { ForwardRef as ReactComponent };